import Quiz from '../api/quiz';
import { applicationSave, applicationFetch } from './applicationActions';

export const saveQuiz = applicationSave(Quiz);
export const fetchQuiz = applicationFetch(Quiz);
